import { render, staticRenderFns } from "./AgentDailyRevenue.vue?vue&type=template&id=2b7a1cba&scoped=true"
import script from "./AgentDailyRevenue.vue?vue&type=script&lang=js"
export * from "./AgentDailyRevenue.vue?vue&type=script&lang=js"
import style0 from "./AgentDailyRevenue.vue?vue&type=style&index=0&id=2b7a1cba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a1cba",
  null
  
)

export default component.exports